import { makeAutoObservable } from 'mobx';
import { Utils } from '../utils/Utils';

export class InternalWall {
    _id = null;
    _closetId = null;
    _pageNo = null;
    _scaleOnPdf = 1;
    _length = 24;
    _depth = 2.5;
    _coordinate = { x: 0, y: 0 };
    _normal = { x: 0, y: 0 };
    _rotation = 0;
    _metaData = {};

    constructor(
        id,
        closetId,
        pageNo,
        scale,
        length,
        depth,
        rotation,
        position,
        normal,
    ) {
        makeAutoObservable(this);
        this._id = id;
        this._closetId = closetId;
        this._pageNo = pageNo;
        this._scaleOnPdf = scale;
        this._length = length;
        this._depth = depth;
        this._coordinate = position;
        this._metaData = {
            faces: [
                { customId: Utils.generateUuid() },
                { customId: Utils.generateUuid() },
            ],
        };
        this.setRotation(rotation);
        this.setNormal(normal);
    }

    get id() {
        return this._id;
    }

    get coordinate() {
        return this._coordinate;
    }

    get pageNo() {
        return this._pageNo;
    }

    get scaleOnPdf() {
        return this._scaleOnPdf;
    }

    get closetId() {
        return this._closetId;
    }

    get length() {
        return this._length;
    }
    get depth() {
        return this._depth;
    }
    get rotation() {
        return this._rotation;
    }
    get normal() {
        return this._normal;
    }

    setClosetId(closetId) {
        this._closetId = closetId;
    }

    setCoordinate(coordinate) {
        this._coordinate = coordinate;
    }

    setLength(length) {
        this._length = length;
    }

    setDepth(depth) {
        this._depth = depth;
    }
    setRotation(rotation) {
        if (rotation < 0) {
            rotation += 360;
        }
        this._rotation = rotation;
        const rotationRadians = this.rotation * (Math.PI / 180);
        const normal = {
            x: Math.cos(rotationRadians),
            y: Math.sin(rotationRadians),
            z: 0,
        };
        const magnitude = Math.sqrt(normal.x * normal.x + normal.y * normal.y);
        normal.x /= magnitude;
        normal.y /= magnitude;
        normal.z = 0;
        this.setNormal(normal);
    }
    setNormal(normal) {
        this._normal = normal;
    }

    isInternalWallInTol(coordinate, scale) {
        const x = coordinate.x;
        const y = coordinate.y;
        const cX = this.coordinate.x;
        const cY = this.coordinate.y;
        const width = this.length / scale;
        const height = this.depth / scale;
        if (
            x >= cX - width &&
            x <= cX + width &&
            y >= cY - height &&
            y <= cY + height
        ) {
            return true;
        }
        return false;
    }

    findInternalWallByCoordinate(coordinate) {
        const x = coordinate.x;
        const y = coordinate.y;
        const cX = this.coordinate.x;
        const cY = this.coordinate.y;

        const width = this.length;
        const height = this.depth;
        if (
            x >= cX - width / 2 &&
            x <= cX + width / 2 &&
            y >= cY - height / 2 &&
            y <= cY + height / 2
        ) {
            return this;
        }
        return null;
    }

    updateLengthInDirection(length) {
        const dir = this.normal;
        const halfLength = this.length / 2;

        // infer start point
        const p1 = {
            x: this.coordinate.x - dir.x * halfLength,
            y: this.coordinate.y - dir.y * halfLength,
        };

        // set new position
        const newHalf = length / 2;
        this._coordinate.x = p1.x + dir.x * newHalf;
        this._coordinate.y = p1.y + dir.y * newHalf;

        this.setLength(length);
    }
}
